import {Component, ElementRef, HostListener, ViewChild} from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';
import {ICellEditorParams} from 'ag-grid-community';
import {IDepartment} from '../../../../shared/shared-models/stock/departments';
import {StockItem} from '../../../../shared-utilities/models-old/datastructures';
import {GridUtils} from '../../../../shared-utilities/utils-old/grid-utils-old/grid-utils';
import {NGPReport} from '../../../../shared-utilities/models-old/ngp-reports/ngp-report';
import {Store} from '@ngrx/store';
import {IconsEnum} from '../../../shared-icons/models/icons.enum';
import {
  decodeOnHoldCode,
  encodeOnHoldCode,
} from '../../../../shared/shared-module-ui/utils/on-hold-code/on-hold-code.utils';
import {_ON_HOLD_TYPES} from '../../../../features/settings-new/models/on-hold-code/on-hold-code.interface';

@Component({
  selector: 'app-cell-editor-multi-select',
  templateUrl: './cell-editor-multi-select-on-hold.component.html',
  styleUrls: ['./cell-editor-multi-select-on-hold.component.scss'],
  standalone: false,
})
export class CellEditorMultiSelectOnHoldComponent implements ICellEditorAngularComp {
  @ViewChild('input', {static: true}) input: ElementRef;
  @ViewChild('selectElement', {static: true}) selectElement: ElementRef<HTMLSelectElement>;
  onHoldTypes = {..._ON_HOLD_TYPES};
  value: number;
  params: ICellEditorParams;
  width: number;
  colDefField: string;
  icons: typeof IconsEnum = IconsEnum;
  departments: IDepartment[] = [];
  displayAbove = false;
  selectedValues: string[] = [];
  showOptions = false;

  constructor(
    private readonly store: Store,
  ) {
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (this.showOptions) {
      this.adjustPosition();
    }
  }

  agInit(params: ICellEditorParams): void {
    this.params = params;
    this.params.data = structuredClone(params.data);
    this.params.colDef = {...params.colDef};
    this.colDefField = params.colDef.field;
    this.value = this.params.data[this.colDefField] as number;
    this.width = this.params.colDef.width;
    this.params.data.originalValue = {...params.data.originalValue};
    this.params.data.originalValue[this.colDefField] = {...params.data.originalValue[this.colDefField]};
    this.selectedValues = decodeOnHoldCode(+this.value, {returnCodes: false, isSupplier: false}) ?? [];
    this.params.api.autoSizeColumns([this.params.colDef]);
    params.api.setColumnWidths([
      {key: params.colDef.field, newWidth: 210},
    ]);
  }


  getValue(): string {
    this.params.data.isError = decodeOnHoldCode(+this.value) === null;
    this.params.data.isEdited = this.params.data[this.colDefField] !== this.params.data.originalValue[this.colDefField].value;
    if (this.value < 0) {
      this.value = 0;
    }
    this.params.data[this.colDefField] = structuredClone(this.params.data[this.colDefField]);
    this.params.data[this.colDefField] = this.value;
    GridUtils.updateErrorAndForceRefreshForOnHoldCode(this.params, +this.value);
    GridUtils.updateIsEditedAndForceRefresh(this.params);
    GridUtils.updateSingleItem(this.params.data as NGPReport | StockItem, this.colDefField, this.value, this.store, 'stock-manager');
    return this.params.data[this.colDefField] === '' ? this.params.data.originalValue[this.colDefField].value as string : this.value.toString();
  }

  refresh(params: ICellEditorParams<NGPReport | StockItem, string | number>): boolean {
    GridUtils.updateIsEditedAndForceRefresh(this.params);
    return false;
  }

  afterGuiAttached(): void {
    this.input.nativeElement.focus();
  }

  onUndoChangesClick(): void {
    this.value = this.params.data.originalValue[this.colDefField].value;
    this.params.data[this.colDefField] = this.value;
    GridUtils.removeIsEditingFlagAndDispatch(this.params.data as NGPReport | StockItem, this.colDefField, this.store, 'stock-manager');
    GridUtils.updateIsEditedAndForceRefresh(this.params);
  }

  toggleDropdown(): void {
    this.showOptions = !this.showOptions;
    if (this.showOptions) {
      this.adjustPosition();
    }
  }


  adjustPosition(): void {
    const inputRect = this.input.nativeElement.getBoundingClientRect();
    const optionsHeight = 400;
    const spaceBelow = window.innerHeight - inputRect.bottom;
    const spaceAbove = inputRect.top;

    this.displayAbove = spaceBelow < optionsHeight && spaceAbove > optionsHeight;
  }

  selectText(): void {
    setTimeout((): void => {
      this.input.nativeElement.focus();
      this.input.nativeElement.setSelectionRange(0, this.value.toString().length);
      this.input.nativeElement.select();
    }, 1);
  }

  toggleSelection(value: string): void {
    if (this.selectedValues.includes(this.onHoldTypes[value] as unknown as string)) {
      this.selectedValues = this.selectedValues?.filter((v: string) => v !== this.onHoldTypes[value] as unknown as string);
    } else {
      this.selectedValues.push(this.onHoldTypes[value] as unknown as string);
    }
  }

  onCancelButtonClick(): void {
    this.params.data[this.colDefField] = this.value;
    this.toggleDropdown();
    this.selectText();
  }

  onConfirmButtonClick(): void {
    this.value = this.selectedValues.length > 0 ? encodeOnHoldCode(this.selectedValues) : 0;
    this.params.data[this.colDefField] = this.value;
    this.params.value = this.value;
    this.toggleDropdown();
    this.selectText();

  }
}
